import { Measurements } from './measurements';

export default Measurements;
